import { useRouteLoaderData } from '@remix-run/react';

import type { Page } from '~/interfaces/page';
import type { Site } from '~/interfaces/site';
import type { Subscription } from '~/interfaces/subscriptions';
import type { RootLoaderData } from '~/root';

interface UsePremiumPageGateResult {
  isPremiumGated: boolean;
  hasPremiumAccess: boolean;
  isFetchingSubscription: boolean;
  subscription: Subscription | undefined;
}

const usePremiumPageGate = (page?: Page, site?: Site): UsePremiumPageGateResult => {
  const rootData = useRouteLoaderData('root') as RootLoaderData | undefined;

  const isPremiumGated = page?.premium === true && site?.publication?.premium_enabled === true;
  const subscription = rootData?.subscription;
  const isFetchingSubscription = rootData?.isFetchingSubscription ?? false;
  const hasPremiumAccess = !isPremiumGated || (subscription?.tier === 'premium' && subscription?.status === 'active');

  return {
    isPremiumGated,
    hasPremiumAccess,
    isFetchingSubscription,
    subscription,
  };
};

export default usePremiumPageGate;
